module.exports = __webpack_public_path__ + "static/vib_play8s-26616f32117a5f26817897fbf0995fd3.jpg";